import { useQuery } from "@tanstack/react-query";

import QueryKeys from "@app/constants/QueryKeys.ts";
import { useDepartmentService } from "@app/services/api/useDepartmentService.ts";

export const useDepartments = () => {
  const { fetchDepartment } = useDepartmentService();

  const { data, isPending, error } = useQuery({
    queryKey: [QueryKeys.DEPARTMENTS],
    queryFn: fetchDepartment,
  });

  return {
    departments: data ?? [],
    isPending,
    error,
  };
};
